/** Shared Tailwind tokens for /start subpages and modals (aligned with Start Dashboard / Finance). */

export const startPagePadding = 'p-6 md:p-8';

export const startPageMaxWidth = 'max-w-5xl mx-auto w-full';

export const startCard =
  'rounded-xl border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 shadow-sm';

export const startCardPadding = 'p-5';

export const startCardPaddingCompact = 'p-4';

// Scales down on small screens so longer page titles stay readable rather than
// wrapping into a tall stack. Only StartSubpageLayout consumes this.
export const startPageTitle = 'text-2xl sm:text-3xl font-bold text-gray-800 dark:text-white';

export const startPageSubtitle = 'text-sm text-gray-500 dark:text-gray-400 mt-1';

// min-h/-w keep it a reliable touch target on tablets; -ml pulls the added padding
// back so the button still lines up flush with the page gutter.
export const startBackButton =
  'inline-flex items-center gap-2 min-h-[44px] px-2 -ml-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors';

export const startPrimaryButton =
  'px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors';

export const startSecondaryButton =
  'px-4 py-2 text-sm font-medium rounded-lg transition-colors bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-700';

export const startInput =
  'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 border-gray-300 text-gray-900 dark:bg-gray-700 dark:border-gray-600 dark:text-white placeholder-gray-500 dark:placeholder-gray-400';

export const startLabel = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1';

export const startCtaButton =
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors text-base shadow-sm w-full sm:w-auto';

export const startStatusBadge =
  'inline-flex items-center gap-1.5 min-h-[44px] px-5 py-2.5 font-semibold rounded-lg text-base';

export const startSidebarLink =
  'w-full flex items-center gap-3 p-4 rounded-xl border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-red-200 dark:hover:border-red-800/50 transition-all text-left cursor-pointer';
